// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Homepage V2 — Foundation layer (spacing, typography, CTA, card, image tokens).
 * Scoped to .mh2v2-page. Import before HomePageV2.css section styles.
 */

.mh2v2-page {
  /* Brand colors (homepage scope) */
  --cream: #efe4d3;
  --light: #f5f3f1;
  --white: #ffffff;
  --charcoal: #4b4450;
  --text: #433d43;
  --muted: #6b666b;

  --salmon: #de7f7d;
  --coral: #e57257;
  --mustard: #d7b85c;
  --pink: #dc8a92;
  --mint: #8eb9b2;
  --teal: #6f9f9a;
  --gold: #d8b04e;

  /* Spacing scale */
  --mh2-space-xs: 4px;
  --mh2-space-sm: 8px;
  --mh2-space-md: 16px;
  --mh2-space-lg: 24px;
  --mh2-space-xl: 32px;
  --mh2-space-2xl: 48px;

  --mh2-section-py: 64px;
  --mh2-section-py-sm: 48px;
  --mh2-section-pb: 72px;
  --mh2-container-gutter: 24px;
  --mh2-container-gutter-mobile: 20px;

  --mh2-gap-sm: 14px;
  --mh2-gap-md: 20px;
  --mh2-gap-lg: 28px;

  --mh2-heading-gap: 12px;
  --mh2-title-gap: 22px;
  --mh2-stack-gap: 18px;

  /* Shape & elevation */
  --radius-lg: 28px;
  --radius-md: 20px;
  --radius-sm: 14px;
  --radius-pill: 999px;
  --shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  --shadow-hover: 0 14px 40px rgba(0, 0, 0, 0.12);

  /* Motion & focus */
  --ease-out: cubic-bezier(0.25, 0.46, 0.45, 0.94);
  --transition-fast: 180ms var(--ease-out);
  --transition-base: 220ms var(--ease-out);
  --transition-slow: 260ms var(--ease-out);
  --focus-ring: 2px solid var(--teal);
  --focus-ring-offset: 2px;

  /* Layout */
  --container: var(--twentytwentysix-container-max, 1280px);

  /* Typography roles */
  --mh2-font-display: "fabulosa", serif;
  --mh-font-display: var(--mh2-font-display);
  --mh2-line-body: 1.65;
  --mh2-line-heading: 1.15;
  --mh2-size-body: 1.05rem;
  --mh2-size-body-sm: 0.95rem;
  --mh2-size-eyebrow: 0.95rem;
  --mh2-size-section-title: 1.1rem;

  /* Card & image */
  --mh2-card-padding: var(--mh2-space-md);
  --mh2-card-padding-lg: var(--mh2-space-lg);
  --mh2-card-radius: var(--radius-md);
  --mh2-card-radius-lg: var(--radius-lg);
  --mh2-img-radius: var(--radius-md);
  --mh2-overlay-gradient: linear-gradient(to top, rgba(0, 0, 0, 0.55), transparent 60%);
}

/* Container */
.mh2v2-page .mh2v2-container {
  width: min(var(--container), calc(100% - (var(--mh2-container-gutter) * 2)));
  margin: 0 auto;
}

/* Unified section rhythm */
.mh2v2-page .mh2v2-stories,
.mh2v2-page .mh2v2-now,
.mh2v2-page .mh2v2-programs,
.mh2v2-page .mh2v2-testimonials,
.mh2v2-page .mh2v2-mlist,
.mh2v2-page .mh2v2-collective,
.mh2v2-page .mh2v2-about {
  padding: var(--mh2-section-py) 0 var(--mh2-section-pb);
}

.mh2v2-page .mh2v2-welcome {
  padding: var(--mh2-section-py-sm) 0 var(--mh2-section-pb);
}

/* Section header row (SectionHeader.jsx) */
.mh2v2-page .mh2v2-section-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--mh2-space-md);
  margin-bottom: var(--mh2-title-gap);
  flex-wrap: wrap;
}

.mh2v2-page .mh2v2-h2 {
  margin: 0;
  font-size: var(--mh2-size-section-title);
  font-weight: 700;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  line-height: var(--mh2-line-heading);
  color: var(--text);
}

.mh2v2-page .mh2v2-text-link {
  font-size: var(--mh2-size-body-sm);
  font-weight: 700;
  color: var(--teal);
  text-decoration: none;
  white-space: nowrap;
  transition: color var(--transition-fast);
}

.mh2v2-page .mh2v2-text-link:hover {
  color: var(--charcoal);
}

.mh2v2-page .mh2v2-text-link:focus-visible {
  outline: var(--focus-ring);
  outline-offset: var(--focus-ring-offset);
  border-radius: 2px;
}

/* Typography hierarchy */
.mh2v2-page .mh2v2-eyebrow {
  text-align: center;
  font-size: var(--mh2-size-eyebrow);
  letter-spacing: 0.22em;
  font-weight: 700;
  text-transform: uppercase;
  margin: 0 0 var(--mh2-heading-gap);
}

.mh2v2-page .mh2v2-section-title {
  font-size: var(--mh2-size-section-title);
  letter-spacing: 0.22em;
  font-weight: 700;
  text-transform: uppercase;
  margin: 0 0 var(--mh2-title-gap);
  line-height: var(--mh2-line-heading);
}

.mh2v2-page .mh2v2-copy {
  font-size: var(--mh2-size-body);
  line-height: var(--mh2-line-body);
  color: var(--muted);
}

.mh2v2-page .mh2v2-script {
  line-height: 1.12;
  margin-bottom: var(--mh2-space-md);
}

/* Shared card shell */
.mh2v2-page .mh2v2-story-card,
.mh2v2-page .mh2v2-now-card,
.mh2v2-page .mh2v2-program-card,
.mh2v2-page .mh2v2-testimonial,
.mh2v2-page .mh2v2-category-card,
.mh2v2-page .mh2v2-membership-box,
.mh2v2-page .mh2v2-founder-panel,
.mh2v2-page .mh2v2-happening-card {
  border-radius: var(--mh2-card-radius);
  box-shadow: var(--shadow);
  transition:
    transform var(--transition-base),
    box-shadow var(--transition-base);
}

.mh2v2-page .mh2v2-program-card,
.mh2v2-page .mh2v2-testimonial {
  border-radius: var(--mh2-card-radius-lg);
}

.mh2v2-page .mh2v2-story-card:hover,
.mh2v2-page .mh2v2-now-card:hover,
.mh2v2-page .mh2v2-program-card:hover,
.mh2v2-page .mh2v2-testimonial:hover,
.mh2v2-page .mh2v2-category-card:hover,
.mh2v2-page .mh2v2-happening-card:hover {
  transform: translateY(-3px);
  box-shadow: var(--shadow-hover);
}

.mh2v2-page .mh2v2-testimonial:hover,
.mh2v2-page .mh2v2-happening-card:hover {
  transform: translateY(-2px);
}

.mh2v2-page .mh2v2-story-card:focus-within,
.mh2v2-page .mh2v2-now-card:focus-within,
.mh2v2-page .mh2v2-program-card:focus-within,
.mh2v2-page .mh2v2-testimonial:focus-within,
.mh2v2-page .mh2v2-category-card:focus-within {
  box-shadow: 0 0 0 2px var(--teal);
}

/* Shared image treatment */
.mh2v2-page .mh2v2-story-card img,
.mh2v2-page .mh2v2-now-card img,
.mh2v2-page .mh2v2-program-card__media img,
.mh2v2-page .mh2v2-testimonial__media img,
.mh2v2-page .mh2v2-category-card img,
.mh2v2-page .mh2v2-founder-panel img,
.mh2v2-page .mh2v2-about-founder img,
.mh2v2-page .mh2v2-mlist-hero img {
  width: 100%;
  display: block;
  object-fit: cover;
}

.mh2v2-page .mh2v2-founder-panel img,
.mh2v2-page .mh2v2-about-founder img {
  border-radius: var(--mh2-img-radius);
}

.mh2v2-page .mh2v2-story-card img,
.mh2v2-page .mh2v2-now-card img,
.mh2v2-page .mh2v2-category-card img {
  transition: transform var(--transition-slow);
}

/* CTA system */
.mh2v2-page .mh2v2-pill {
  border-radius: var(--radius-pill);
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: var(--mh2-size-body-sm);
  line-height: 1.2;
}

.mh2v2-page .mh2v2-inline-btn {
  border-radius: var(--radius-pill);
  min-height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}

.mh2v2-page .mh2v2-category-link {
  border-radius: var(--radius-pill);
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mh2v2-page .mh2v2-link-row {
  margin-top: var(--mh2-space-lg);
  padding-top: var(--mh2-space-md);
  padding-bottom: var(--mh2-space-sm);
}

/* Grid gap normalization */
.mh2v2-page .mh2v2-story-grid,
.mh2v2-page .mh2v2-now-grid,
.mh2v2-page .mh2v2-category-grid {
  gap: var(--mh2-gap-md);
}

.mh2v2-page .mh2v2-happening-grid {
  gap: var(--mh2-gap-lg);
}

.mh2v2-page .mh2v2-happening-list,
.mh2v2-page .mh2v2-program-list,
.mh2v2-page .mh2v2-testimonial-list {
  gap: var(--mh2-gap-sm);
}

.mh2v2-page .mh2v2-collective-grid,
.mh2v2-page .mh2v2-about-grid,
.mh2v2-page .mh2v2-footer__grid {
  gap: var(--mh2-gap-lg);
}

/* Footer socials */
.mh2v2-page .mh2v2-socials {
  display: flex;
  gap: var(--mh2-space-sm);
  justify-content: center;
}

.mh2v2-page .mh2v2-socials span {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--teal);
  color: var(--white);
  display: grid;
  place-items: center;
  font-size: 0.75rem;
  font-weight: 700;
  cursor: pointer;
  transition: transform var(--transition-fast), opacity var(--transition-fast);
}

.mh2v2-page .mh2v2-socials span:hover {
  transform: translateY(-1px);
  opacity: 0.9;
}

/* M List hero image */
.mh2v2-page .mh2v2-mlist-hero img {
  height: 260px;
}

/* Mobile foundation stabilization */
@media (max-width: 768px) {
  .mh2v2-page {
    --mh2-section-py: 48px;
    --mh2-section-py-sm: 40px;
    --mh2-section-pb: 56px;
    --mh2-container-gutter: var(--mh2-container-gutter-mobile);
    --mh2-gap-lg: 22px;
    --mh2-gap-md: 16px;
  }

  .mh2v2-page .mh2v2-container {
    width: min(var(--container), calc(100% - (var(--mh2-container-gutter) * 2)));
  }

  .mh2v2-page .mh2v2-section-head {
    flex-direction: column;
    align-items: flex-start;
  }

  .mh2v2-page .mh2v2-pill,
  .mh2v2-page .mh2v2-pill--region {
    min-height: 44px;
  }

  .mh2v2-page .mh2v2-inline-btn {
    min-height: 40px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/twentytwentysix/styles/homepageV2Foundation.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;;EAEhB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;;EAEf,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;;EAErB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,mCAAmC;;EAEnC,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;;EAElB,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;;EAErB,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,yCAAyC;EACzC,+CAA+C;;EAE/C,mBAAmB;EACnB,gDAAgD;EAChD,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,mCAAmC;EACnC,wBAAwB;;EAExB,WAAW;EACX,yDAAyD;;EAEzD,qBAAqB;EACrB,qCAAqC;EACrC,0CAA0C;EAC1C,qBAAqB;EACrB,wBAAwB;EACxB,wBAAwB;EACxB,2BAA2B;EAC3B,2BAA2B;EAC3B,gCAAgC;;EAEhC,iBAAiB;EACjB,uCAAuC;EACvC,0CAA0C;EAC1C,mCAAmC;EACnC,sCAAsC;EACtC,kCAAkC;EAClC,qFAAqF;AACvF;;AAEA,cAAc;AACd;EACE,4EAA4E;EAC5E,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;;;;;;;EAOE,sDAAsD;AACxD;;AAEA;EACE,yDAAyD;AAC3D;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,wBAAwB;EACxB,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,wCAAwC;EACxC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,kCAAkC;EAClC,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA,sBAAsB;AACtB;;;;;;;;EAQE,qCAAqC;EACrC,yBAAyB;EACzB;;qCAEmC;AACrC;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;;;;;;EAME,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;;;;EAKE,iCAAiC;AACnC;;AAEA,2BAA2B;AAC3B;;;;;;;;EAQE,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;;EAGE,4CAA4C;AAC9C;;AAEA,eAAe;AACf;EACE,iCAAiC;EACjC,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA,2BAA2B;AAC3B;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,aAAa;AACf;;AAEA,oCAAoC;AACpC;EACE;IACE,sBAAsB;IACtB,yBAAyB;IACzB,sBAAsB;IACtB,0DAA0D;IAC1D,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,4EAA4E;EAC9E;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/*\n * Homepage V2 — Foundation layer (spacing, typography, CTA, card, image tokens).\n * Scoped to .mh2v2-page. Import before HomePageV2.css section styles.\n */\n\n.mh2v2-page {\n  /* Brand colors (homepage scope) */\n  --cream: #efe4d3;\n  --light: #f5f3f1;\n  --white: #ffffff;\n  --charcoal: #4b4450;\n  --text: #433d43;\n  --muted: #6b666b;\n\n  --salmon: #de7f7d;\n  --coral: #e57257;\n  --mustard: #d7b85c;\n  --pink: #dc8a92;\n  --mint: #8eb9b2;\n  --teal: #6f9f9a;\n  --gold: #d8b04e;\n\n  /* Spacing scale */\n  --mh2-space-xs: 4px;\n  --mh2-space-sm: 8px;\n  --mh2-space-md: 16px;\n  --mh2-space-lg: 24px;\n  --mh2-space-xl: 32px;\n  --mh2-space-2xl: 48px;\n\n  --mh2-section-py: 64px;\n  --mh2-section-py-sm: 48px;\n  --mh2-section-pb: 72px;\n  --mh2-container-gutter: 24px;\n  --mh2-container-gutter-mobile: 20px;\n\n  --mh2-gap-sm: 14px;\n  --mh2-gap-md: 20px;\n  --mh2-gap-lg: 28px;\n\n  --mh2-heading-gap: 12px;\n  --mh2-title-gap: 22px;\n  --mh2-stack-gap: 18px;\n\n  /* Shape & elevation */\n  --radius-lg: 28px;\n  --radius-md: 20px;\n  --radius-sm: 14px;\n  --radius-pill: 999px;\n  --shadow: 0 10px 30px rgba(0, 0, 0, 0.08);\n  --shadow-hover: 0 14px 40px rgba(0, 0, 0, 0.12);\n\n  /* Motion & focus */\n  --ease-out: cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  --transition-fast: 180ms var(--ease-out);\n  --transition-base: 220ms var(--ease-out);\n  --transition-slow: 260ms var(--ease-out);\n  --focus-ring: 2px solid var(--teal);\n  --focus-ring-offset: 2px;\n\n  /* Layout */\n  --container: var(--twentytwentysix-container-max, 1280px);\n\n  /* Typography roles */\n  --mh2-font-display: \"fabulosa\", serif;\n  --mh-font-display: var(--mh2-font-display);\n  --mh2-line-body: 1.65;\n  --mh2-line-heading: 1.15;\n  --mh2-size-body: 1.05rem;\n  --mh2-size-body-sm: 0.95rem;\n  --mh2-size-eyebrow: 0.95rem;\n  --mh2-size-section-title: 1.1rem;\n\n  /* Card & image */\n  --mh2-card-padding: var(--mh2-space-md);\n  --mh2-card-padding-lg: var(--mh2-space-lg);\n  --mh2-card-radius: var(--radius-md);\n  --mh2-card-radius-lg: var(--radius-lg);\n  --mh2-img-radius: var(--radius-md);\n  --mh2-overlay-gradient: linear-gradient(to top, rgba(0, 0, 0, 0.55), transparent 60%);\n}\n\n/* Container */\n.mh2v2-page .mh2v2-container {\n  width: min(var(--container), calc(100% - (var(--mh2-container-gutter) * 2)));\n  margin: 0 auto;\n}\n\n/* Unified section rhythm */\n.mh2v2-page .mh2v2-stories,\n.mh2v2-page .mh2v2-now,\n.mh2v2-page .mh2v2-programs,\n.mh2v2-page .mh2v2-testimonials,\n.mh2v2-page .mh2v2-mlist,\n.mh2v2-page .mh2v2-collective,\n.mh2v2-page .mh2v2-about {\n  padding: var(--mh2-section-py) 0 var(--mh2-section-pb);\n}\n\n.mh2v2-page .mh2v2-welcome {\n  padding: var(--mh2-section-py-sm) 0 var(--mh2-section-pb);\n}\n\n/* Section header row (SectionHeader.jsx) */\n.mh2v2-page .mh2v2-section-head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: var(--mh2-space-md);\n  margin-bottom: var(--mh2-title-gap);\n  flex-wrap: wrap;\n}\n\n.mh2v2-page .mh2v2-h2 {\n  margin: 0;\n  font-size: var(--mh2-size-section-title);\n  font-weight: 700;\n  letter-spacing: 0.22em;\n  text-transform: uppercase;\n  line-height: var(--mh2-line-heading);\n  color: var(--text);\n}\n\n.mh2v2-page .mh2v2-text-link {\n  font-size: var(--mh2-size-body-sm);\n  font-weight: 700;\n  color: var(--teal);\n  text-decoration: none;\n  white-space: nowrap;\n  transition: color var(--transition-fast);\n}\n\n.mh2v2-page .mh2v2-text-link:hover {\n  color: var(--charcoal);\n}\n\n.mh2v2-page .mh2v2-text-link:focus-visible {\n  outline: var(--focus-ring);\n  outline-offset: var(--focus-ring-offset);\n  border-radius: 2px;\n}\n\n/* Typography hierarchy */\n.mh2v2-page .mh2v2-eyebrow {\n  text-align: center;\n  font-size: var(--mh2-size-eyebrow);\n  letter-spacing: 0.22em;\n  font-weight: 700;\n  text-transform: uppercase;\n  margin: 0 0 var(--mh2-heading-gap);\n}\n\n.mh2v2-page .mh2v2-section-title {\n  font-size: var(--mh2-size-section-title);\n  letter-spacing: 0.22em;\n  font-weight: 700;\n  text-transform: uppercase;\n  margin: 0 0 var(--mh2-title-gap);\n  line-height: var(--mh2-line-heading);\n}\n\n.mh2v2-page .mh2v2-copy {\n  font-size: var(--mh2-size-body);\n  line-height: var(--mh2-line-body);\n  color: var(--muted);\n}\n\n.mh2v2-page .mh2v2-script {\n  line-height: 1.12;\n  margin-bottom: var(--mh2-space-md);\n}\n\n/* Shared card shell */\n.mh2v2-page .mh2v2-story-card,\n.mh2v2-page .mh2v2-now-card,\n.mh2v2-page .mh2v2-program-card,\n.mh2v2-page .mh2v2-testimonial,\n.mh2v2-page .mh2v2-category-card,\n.mh2v2-page .mh2v2-membership-box,\n.mh2v2-page .mh2v2-founder-panel,\n.mh2v2-page .mh2v2-happening-card {\n  border-radius: var(--mh2-card-radius);\n  box-shadow: var(--shadow);\n  transition:\n    transform var(--transition-base),\n    box-shadow var(--transition-base);\n}\n\n.mh2v2-page .mh2v2-program-card,\n.mh2v2-page .mh2v2-testimonial {\n  border-radius: var(--mh2-card-radius-lg);\n}\n\n.mh2v2-page .mh2v2-story-card:hover,\n.mh2v2-page .mh2v2-now-card:hover,\n.mh2v2-page .mh2v2-program-card:hover,\n.mh2v2-page .mh2v2-testimonial:hover,\n.mh2v2-page .mh2v2-category-card:hover,\n.mh2v2-page .mh2v2-happening-card:hover {\n  transform: translateY(-3px);\n  box-shadow: var(--shadow-hover);\n}\n\n.mh2v2-page .mh2v2-testimonial:hover,\n.mh2v2-page .mh2v2-happening-card:hover {\n  transform: translateY(-2px);\n}\n\n.mh2v2-page .mh2v2-story-card:focus-within,\n.mh2v2-page .mh2v2-now-card:focus-within,\n.mh2v2-page .mh2v2-program-card:focus-within,\n.mh2v2-page .mh2v2-testimonial:focus-within,\n.mh2v2-page .mh2v2-category-card:focus-within {\n  box-shadow: 0 0 0 2px var(--teal);\n}\n\n/* Shared image treatment */\n.mh2v2-page .mh2v2-story-card img,\n.mh2v2-page .mh2v2-now-card img,\n.mh2v2-page .mh2v2-program-card__media img,\n.mh2v2-page .mh2v2-testimonial__media img,\n.mh2v2-page .mh2v2-category-card img,\n.mh2v2-page .mh2v2-founder-panel img,\n.mh2v2-page .mh2v2-about-founder img,\n.mh2v2-page .mh2v2-mlist-hero img {\n  width: 100%;\n  display: block;\n  object-fit: cover;\n}\n\n.mh2v2-page .mh2v2-founder-panel img,\n.mh2v2-page .mh2v2-about-founder img {\n  border-radius: var(--mh2-img-radius);\n}\n\n.mh2v2-page .mh2v2-story-card img,\n.mh2v2-page .mh2v2-now-card img,\n.mh2v2-page .mh2v2-category-card img {\n  transition: transform var(--transition-slow);\n}\n\n/* CTA system */\n.mh2v2-page .mh2v2-pill {\n  border-radius: var(--radius-pill);\n  min-height: 44px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--mh2-size-body-sm);\n  line-height: 1.2;\n}\n\n.mh2v2-page .mh2v2-inline-btn {\n  border-radius: var(--radius-pill);\n  min-height: 36px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n}\n\n.mh2v2-page .mh2v2-category-link {\n  border-radius: var(--radius-pill);\n  min-height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.mh2v2-page .mh2v2-link-row {\n  margin-top: var(--mh2-space-lg);\n  padding-top: var(--mh2-space-md);\n  padding-bottom: var(--mh2-space-sm);\n}\n\n/* Grid gap normalization */\n.mh2v2-page .mh2v2-story-grid,\n.mh2v2-page .mh2v2-now-grid,\n.mh2v2-page .mh2v2-category-grid {\n  gap: var(--mh2-gap-md);\n}\n\n.mh2v2-page .mh2v2-happening-grid {\n  gap: var(--mh2-gap-lg);\n}\n\n.mh2v2-page .mh2v2-happening-list,\n.mh2v2-page .mh2v2-program-list,\n.mh2v2-page .mh2v2-testimonial-list {\n  gap: var(--mh2-gap-sm);\n}\n\n.mh2v2-page .mh2v2-collective-grid,\n.mh2v2-page .mh2v2-about-grid,\n.mh2v2-page .mh2v2-footer__grid {\n  gap: var(--mh2-gap-lg);\n}\n\n/* Footer socials */\n.mh2v2-page .mh2v2-socials {\n  display: flex;\n  gap: var(--mh2-space-sm);\n  justify-content: center;\n}\n\n.mh2v2-page .mh2v2-socials span {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: var(--teal);\n  color: var(--white);\n  display: grid;\n  place-items: center;\n  font-size: 0.75rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: transform var(--transition-fast), opacity var(--transition-fast);\n}\n\n.mh2v2-page .mh2v2-socials span:hover {\n  transform: translateY(-1px);\n  opacity: 0.9;\n}\n\n/* M List hero image */\n.mh2v2-page .mh2v2-mlist-hero img {\n  height: 260px;\n}\n\n/* Mobile foundation stabilization */\n@media (max-width: 768px) {\n  .mh2v2-page {\n    --mh2-section-py: 48px;\n    --mh2-section-py-sm: 40px;\n    --mh2-section-pb: 56px;\n    --mh2-container-gutter: var(--mh2-container-gutter-mobile);\n    --mh2-gap-lg: 22px;\n    --mh2-gap-md: 16px;\n  }\n\n  .mh2v2-page .mh2v2-container {\n    width: min(var(--container), calc(100% - (var(--mh2-container-gutter) * 2)));\n  }\n\n  .mh2v2-page .mh2v2-section-head {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .mh2v2-page .mh2v2-pill,\n  .mh2v2-page .mh2v2-pill--region {\n    min-height: 44px;\n  }\n\n  .mh2v2-page .mh2v2-inline-btn {\n    min-height: 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
